




















































import { Component, Watch, Vue } from 'vue-property-decorator';
import Search from '../components/menu/Search.vue';
import Announcement from '../components/menu/Announcement.vue';
import Consultation from '../components/menu/Consultation.vue';
import Account from '../components/menu/Account.vue';
import Note from '../components/menu/Note.vue';
import Task from '../components/menu/Task.vue';
import Talk from '../components/menu/Talk.vue';
import firebase, { firestore } from 'firebase';
import {FirebaseConnection, Config, Authentications} from '../Classes/Infrastractures';
import {DataInitializeUsecase} from '../Classes/Usecases';
import { State, Getter, Mutation, namespace} from 'vuex-class';
import { FunctionsState } from '../stores/functions/types';
import { Functions, Function, Post } from '../Classes/Entities';
import { PostFactory } from '../Classes/Entities/Chat/PostFactory';
import router from '../router';
import { ThreadRepository } from '../Classes/Infrastractures/ThreadRepository';

const FunctinosModule = namespace('functions');
const ThreadRepositoryModule = namespace('threadRepository');


@Component({
  components: {
    Search,
    Account,
    Announcement,
    Consultation,
    Note,
    Task,
    Talk
  },
})
export default class Home extends Vue {
  @ThreadRepositoryModule.State('threadRepository') 
  public threadRepository!: FunctionsState;

  @FunctinosModule.State('functions') 
  public functions!: FunctionsState;

  @FunctinosModule.Getter('functionMap') 
  public functionMap!: Functions;

  public get announcement():Function<Post> {
    return this.functionMap.announcement;
  }
  public get note():Function<Post> {
    return this.functionMap.note;
  }
  public get consultation():Function<Post> {
    return this.functionMap.consultation;
  }
  public get task():Function<Post> {
    return this.functionMap.task;
  }
  public get talk():Function<Post> {
    return this.functionMap.talk;
  }

  public onMenuClick(e:Event|null) {
    
    const isEvent = (data:Event|null):data is Event => {
      return data != null && data.target != undefined;
    }
    if (isEvent(e)) {
      const element:any = e.target
      if (element.constructor.name !== 'HTMLAnchorElement') return;
    }

    const checkBox:HTMLElement|null = document.getElementById('drawerCheckbox');
    if (checkBox == null) return;

    const isCheckBox = (data:any):data is HTMLInputElement => {
      return data.checked != undefined;
    }
    if (isCheckBox(checkBox)) {
      checkBox.checked = false;
    }
  }
}
